<template>
    <Slider v-model="text" :min="min" :max="max" :step="step" :disabled="disabled" :orientation="vertical" :range="range" />
</template>

<script>
import { ref, watch } from 'vue'
import Slider from 'primevue/slider';

export default {
    name: 'tw-slider',
    components: {
        Slider
    },
    setup(props, context) {
        const text = ref(props.value)

        watch(text, (newValue) => {
            context.emit('update:value', newValue)
        })

        return {
            text
        }
    },
    props: {
        value: Number,
        min: Number,
        max: Number,
        step: Number,
        disabled: Boolean,
        range: Boolean,
        vertical: String
    }
}
</script>
